// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-o_fM","advertDetailHeaderLocation__value":"c-o_fN"};